import styled from 'styled-components'

export const PreviewCard = styled.div`
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const PreviewCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`

export const PreviewCardIcon = styled.span`
  font-size: 18px;
`

export const PreviewCardTitle = styled.h4`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
`

export const PreviewCardDescription = styled.p`
  margin: 0;
  font-size: 13px;
  color: #666;
  line-height: 1.5;
`

export const EmptyPreview = styled.div`
  text-align: center;
  padding: 20px;
  color: #999;
  font-style: italic;
`

export const TruncatedText = styled.span`
  display: block;
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
